import React, { useEffect } from 'react'
import { recommendedArticleAdStyles } from '../AdUnits/adStyles'

/**
 * 文章頁演算法推薦模組廣告
 *
 * Ad unit = `BT_article_1`, `BT_article_2`, `BT_article_3`
 */
export default function RecommendedArticleAd(props) {
  const { adId, eventName } = props
  useEffect(() => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ event: eventName })
  }, [eventName])
  return (
    <div css={recommendedArticleAdStyles}>
      <div id={adId} />
    </div>
  )
}
